import { FC } from "react";

import { ConfirmDeleteOneModal } from "src/components/Modal";
import { useToast } from "src/components/Toasts/ToastContainer";
import { mapToModalError } from "src/errors";
import { useDeleteAttachment } from "src/graphql/anti-fraud/queries/attachments/DeleteAttachmentMutation";
import { useT } from "src/internationalization";
import { Attachment } from "src/types/attachment";

export type ConfirmDeleteAttachmentModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  attachment: Attachment;
};

export const ConfirmDeleteAttachmentModal: FC<ConfirmDeleteAttachmentModalProps> = ({
  onClose,
  onConfirm,
  attachment,
}) => {
  const { showSuccessToast } = useToast();
  const t = useT();

  const {
    performMutation: deleteAttachment,
    error,
    loading,
  } = useDeleteAttachment({
    onSuccess: () => {
      showSuccessToast(t("page.alert.modal.attachments.delete.success"));
      onConfirm();
    },
  });

  return (
    <ConfirmDeleteOneModal
      onConfirm={() => {
        deleteAttachment({ id: attachment.id });
      }}
      resourceName={attachment.name ?? ""}
      onClose={onClose}
      loading={loading}
      error={mapToModalError(error)}
    />
  );
};
